var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLogin && _vm.imgsrc)?_c('EntryCard',{attrs:{"imgsrc":_vm.imgsrc,"dataSource":_vm.dataSource,"page":_vm.page}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }